/* unplugin-vue-components disabled */import script from "./allchat.vue?vue&type=script&lang=ts&setup=true"
export * from "./allchat.vue?vue&type=script&lang=ts&setup=true"

import "./allchat.vue?vue&type=style&index=0&id=be88f216&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be88f216"]])

export default __exports__